module.exports = __webpack_public_path__ + "static/img/organization_pic@2x.c48a85b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180102/organization_pic@2x.png
// module id = 236
// module chunks = 1